import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@trellis/roots/sheet'

import type { RegistryRowValue } from './LineItemRow'
import { RegistryItemBrowser } from './RegistryItemBrowser'

interface RegistryItemBrowserSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onAdd: (items: RegistryRowValue[]) => void
}

export function RegistryItemBrowserSheet({
  open,
  onOpenChange,
  onAdd,
}: RegistryItemBrowserSheetProps) {
  function handleAdd(items: RegistryRowValue[]) {
    onAdd(items)
    onOpenChange(false)
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:w-3/4 sm:max-w-5xl">
        <SheetHeader>
          <SheetTitle>Browse registry</SheetTitle>
        </SheetHeader>
        <div className="flex min-h-0 flex-1 flex-col pt-3">
          <RegistryItemBrowser onAdd={handleAdd} onClose={() => onOpenChange(false)} />
        </div>
      </SheetContent>
    </Sheet>
  )
}
